



















import mixins from 'vue-typed-mixins';
import EmailForm from '@/components/email/EmailForm.vue';
import cloneDeep from 'lodash.clonedeep';
import EmailUtils, { AutomatedEmail } from '../../utils/EmailUtils';
export default mixins().extend({
  components: {
    EmailForm,
  },
  computed: {
    id(): number {
      return parseInt(this.$route.params.emailId);
    },
  },
  data(): {
    pristine?: Partial<AutomatedEmail>;
    email?: Partial<AutomatedEmail>;
  } {
    return {
      pristine: undefined,
      email: undefined,
    };
  },
  async mounted() {
    try {
      this.email = await EmailUtils.api.get(this.id);
    } catch (error) {
      this.$alert.show('mounted', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
  methods: {
    async submit() {
      if (this.email) {
        try {
          this.$alert.hide('submit');
          await EmailUtils.api.update(this.email as AutomatedEmail);
          this.pristine = cloneDeep(this.email);
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.default', {
              values: [this.$languageobj('model.email.label')],
            }),
          });
        } catch (error) {
          this.$alert.show('submit', {
            type: 'error',
            messages: this.$handleAPIError(error, this.$refs.observer),
          });
        }
      }
    },
  },
});
